import React, { useState } from 'react';
import classNames from 'classnames';
import { Popover } from 'react-tiny-popover';
import { Link, useHistory, useLocation, } from '@hummingbirdtechgroup/wings-router';
import { Typography, makeStyles } from '@hummingbirdtechgroup/wings-ui';
const useStyles = makeStyles(({ spacing, shadows, palette, zIndex }) => ({
    navItem__wrapper: {
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        minWidth: spacing(7),
        width: 'auto',
    },
    navItem__logo: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'inherit',
        width: spacing(4),
        height: spacing(4),
        minWidth: spacing(4),
        minHeight: spacing(4),
        margin: spacing(1),
    },
    navItem__text: {
        margin: spacing(0, 1),
        fontSize: spacing(1),
        color: 'inherit',
    },
    active: {
        color: palette.grey.offBlack,
        backgroundColor: palette.background.default,
    },
    hover: {
        backgroundColor: `${palette.grey.offBlack}50`,
    },
    disabled: {
        cursor: 'not-allowed',
        color: palette.grey.offBlack,
        backgroundColor: `${palette.grey.offBlack}50`,
    },
    labelContainer: {
        position: 'relative',
        textAlign: 'center',
        background: `${palette.grey.offBlack} 0% 0% no-repeat padding-box`,
        padding: spacing(),
        color: 'white',
        border: `1px solid ${palette.grey.light}`,
        borderRadius: '5px',
        boxShadow: shadows[1],
        width: spacing(15.8),
        opacity: 0.9,
        zIndex: zIndex.leafletMax + 2,
    },
    popoverArrow: {
        content: '',
        position: 'absolute',
        right: '100%',
        top: 11.25,
        width: 0,
        height: 0,
        borderTop: '5px solid transparent',
        borderRight: `8px solid ${palette.grey.offBlack}`,
        borderBottom: '5px solid transparent',
        zIndex: zIndex.leafletMax + 2,
    },
}));
function NavItem({ children, selected = false, disabled = false, onClick, label, icon, variant = 'primary', to, hoverable = true, }) {
    const classes = useStyles();
    const location = useLocation();
    const history = useHistory();
    const [hover, setHover] = useState(false);
    const handleMouseEnter = () => {
        setHover(true);
    };
    const handleMouseLeave = () => {
        setHover(false);
    };
    const renderVariant = () => {
        switch (variant) {
            case 'anchor':
                return (React.createElement("a", { onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, href: to, className: classes.navItem__wrapper, target: "_blank", rel: "noreferrer" },
                    React.createElement("span", { className: classes.navItem__logo }, icon)));
            case 'link':
                return (React.createElement(Link, { onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, to: to, onClick: onClick, className: classes.navItem__wrapper },
                    React.createElement("span", { className: classes.navItem__logo }, icon)));
            default:
                return (React.createElement("div", { onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onClick: to
                        ? () => {
                            history.push(location);
                            window.location.replace(to);
                        }
                        : onClick, className: classNames(classes.navItem__wrapper, {
                        [classes.active]: selected && variant === 'primary',
                        [classes.hover]: hover && variant === 'primary' && !selected && hoverable,
                        [classes.disabled]: disabled,
                    }) }, icon && React.createElement("span", { className: classes.navItem__logo }, icon)));
        }
    };
    return (React.createElement(Popover, { reposition: false, isOpen: hover, positions: ['right'], align: "end", content: React.createElement("div", { style: { margin: '8px' } },
            React.createElement("div", { className: classes.labelContainer },
                React.createElement("div", { className: classes.popoverArrow }),
                React.createElement(Typography, null, children || label))) }, renderVariant()));
}
export default NavItem;
//# sourceMappingURL=NavItem.js.map